module.exports = __webpack_public_path__ + "img/rent.74804c83.svg";